module.exports = __webpack_public_path__ + "static/img/08102744nyab.033a774a.jpg";